import React, { Fragment } from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader,
  ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText, Carousel, CarouselIndicators, CarouselControl
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Navbarh from '../navbar/Navbar';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
import classnames from 'classnames';
import useCotizaciones from '../../hooks/useCotizaciones';
import useProductos from '../../hooks/useProductos';




function Cotizacion() {
  //Uso descontracturado de las variables y funciones del hook useProductos
  const productos = useProductos();
  const { pcotizaciones, permisoAutorizar, color, aVisible, mensajeAlert, cargando, activeTab, searchBy, search,
    colorM, aVisibleM, mensajeAlertM, cargandoM, statusOriginal,
    cotizaciones, tituloTab, rfechaini, rfechafin, currentPageCotizaciones, archivo, ultimoNumeroP,
    paginas, clientes, formData, editar, faltanDatos, requestors, medidaIngresadaEn, inputListMod, documenton,
    editarCliente, editarContacto, editarPprocess, inputList, isDisabled, componentRef, cotizacionImprimir, formType, modal,
    clienteNuevo, contactoNuevo, productoNuevo, modal2, modal3, editarAToolBar, hEditarCotizacion, cotizacionesRechazadas,
    clicNuevaCotizacion, buscarpor, setSearch, onSearchFecha, onDismiss, onChangesRFechaini, clicMostrar, cancelarRechazo,
    onSearch, toggle1, fetchCotizaciones, clicEditar, setCotizacionImprimir, clicAgregarCotizacion, handlePrint,
    handlePageChangeCotizaciones, onChanges, onChangesNumeros, onChangesClientes, onChangesRequestor, actualizarStatusCotizacion,
    setEditarCliente, setEditarPprocess, setEditarContacto, manageCotizacion, toggle, toggle2, toggle3, setClienteNuevo,
    onChangeMedidaEn, setInputList, cancelarCotizacion, cancelarModalCotizacion, handleInputChangeMedidas, setDocumenton,
    handleRemoveClick, cancelarMedidas, handleInputDatos, clicAutorizar, onChangedocumento, setEditarAToolBar, onChangelogodoc,
    setContactoNuevo, setProductoNuevo, } = useCotizaciones();

  return (
    <>
      <Navbarh />
      {pcotizaciones === true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoIosCash className="iconoc floatleft" onClick={() => { toggle1('1'); }} />
              <h3 >{formType}</h3>
            </div>
          </Row>
          <div className="conteiner2">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}

            <Fragment>
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { toggle1('1'); }}
                    >
                      Cotización
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: "none" }}>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { toggle1('2'); }}
                    >
                      Productos
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { toggle1('3'); }}
                    >
                      {tituloTab}
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: "none" }} >
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => { toggle1('4'); }}
                    >
                      Imprimir
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      < div className="col-lg-4 col-md-3 col-sm-12 col-xs-12 text-left" >
                        <button class="cbutton btn-success margintop20px ml-3" onClick={() => { clicNuevaCotizacion() }}> <span class="fa fa-plus"> Nueva cotización</span> </button>
                      </div>
                      <div class="col-lg-2 col-xs-12 text-left " >
                        <FormGroup >
                          <Label ><h5>Busqueda por: </h5></Label>
                          <select name="recibabusqueda" onChange={buscarpor}>
                            <option value="cliente" >Cliente</option>
                            <option value="numero de parte">Número de parte</option>
                            <option value="id de cotizacion" >ID de cotización</option>
                            <option value="fecha">Fecha de cotización</option>
                          </select>
                          <Input
                            type={searchBy !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + searchBy}
                            onChange={searchBy !== "fecha" ? (e) => setSearch(e.target.value) : onSearchFecha}
                            onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                            value={search}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px" >

                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                          <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Del:</InputGroupText>
                              </InputGroupAddon>
                              <Input name="rfechaini" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFechaini} />
                            </InputGroup>
                          </div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                            <InputGroup className="floatrightleft ml-1">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Al:</InputGroupText>
                              </InputGroupAddon>
                              <Input name="rfechafin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFechaini} />
                            </InputGroup>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <button className="cbutton btn-dark floatright  mr-3 marginrightmobil3p " title="Recargar página" onClick={() => { fetchCotizaciones(rfechaini, rfechafin); }}><IoIcons.IoMdRefresh /> Recargar </button>
                    <div >
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                        <Table className=" mb-2 scroll " >
                          <Thead class="thead-secondary">
                            <Tr>
                              <Th>Quote Number</Th>
                              <Th className="minwidth200px">Customer</Th>
                              <Th >Date</Th>
                              <Th>Part Number</Th>
                              <Th className="minwidth200px">Proccess Engineering</Th>
                              <Th>Automotive</Th>
                              <Th className="minwidth80px">Annual Volumen</Th>
                              <Th className="minwidth80px">Estatus</Th>
                              <Th className="minwidth80px">SOP</Th>
                              <Th className="minwidth60px">EOP</Th>
                              {/*<Th className="minwidth60px">Piezas recuperadas</Th>*/}
                              <Th className="minwidth80px">Acciones</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {cotizaciones.map((cotizacion, i) => (
                              <Tr class={cotizacion.color} >
                                <Td>{cotizacion.quoteNumber}</Td>
                                <Td>{cotizacion.cliente}</Td>
                                <Td >{cotizacion.date}</Td>
                                <Td>{cotizacion.numerodeParte}</Td>
                                <Td >{cotizacion.processEngineering}</Td>
                                <Td className="margintopmobil20px" >{cotizacion.automotive}</Td>
                                <Td >{cotizacion.annualVolume}</Td>
                                <Td >{cotizacion.status}</Td>
                                <Td >{cotizacion.SOP}</Td>
                                <Td className={!cotizacion.SOP ? "margintopmobil20px" : ""}>{cotizacion.EOP}</Td>
                                {/*<Td >{cotizacion.piezasNRecuperadas}</Td>*/}
                                <Td className={!cotizacion.EOP ? "margintopmobil20px" : ""}>
                                  <button class="btn-info cbutton mt-1 ml-1" onClick={() => clicMostrar(cotizacion)} title="Detalles de la cotización"> <IoIcons.IoIosListBox /> </button>
                                  <button class="btn-primary cbutton mt-1 ml-1" onClick={() => clicEditar(cotizacion)} title="Editar"> <IoIcons.IoIosCreate /> </button>
                                  {cotizacion.autorizado === true && (<>
                                    <button class="btn-warning cbutton mt-1 ml-1" title="Imprimir cotización" onMouseDown={() => setCotizacionImprimir(cotizacion)} onClick={() => handlePrint()}> <IoIcons.IoIosPrint /> </button>
                                    <a className='cbutton btn-secondary padding10px  mt-1 ml-1' title="Enviar cotización" onClick={() => actualizarStatusCotizacion({ ...cotizacion, status: "Send" }, 1)} href={`mailto:${cotizacion.email}?subject=${encodeURIComponent("Product Information " + cotizacion.quoteNumber) || ''}&body=${"Cuerpo del mensaje"}`}><IoIcons.IoIosMail /></a>
                                  </>)}
                                  <button class="btn-success cbutton mt-1 ml-1" onClick={() => clicAgregarCotizacion(cotizacion)} title="Crear a partir de cotización"> <IoIcons.IoIosAdd /> </button>
                                  {/**<button class="btn-danger cbutton mt-1 ml-1" onClick={() => clicEliminar(cotizaciones)} title="Eliminar"> <IoIcons.IoIosClose /> </button> */}
                                </Td>
                              </Tr>

                            ))}
                          </Tbody>
                        </Table>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                      </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12  ">
                      <div class="floatcenter">
                        <ul class="pagination">
                          <li class={currentPageCotizaciones === 1 ? "page-item disabled" : "page-item"}>
                            <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangeCotizaciones(1)}>«</a>
                          </li>
                          <li class={currentPageCotizaciones === 1 ? "page-item disabled" : "page-item"}>
                            <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangeCotizaciones(currentPageCotizaciones - 1)}>⟨</a>
                          </li>
                          {paginas.map(pagina => (
                            <li class={currentPageCotizaciones === pagina.pagina ? "page-item active" : "page-item "}>
                              <a class="page-link " onClick={() => handlePageChangeCotizaciones(pagina.pagina)}>{pagina.pagina}</a>
                            </li>
                          ))}
                          <li class={currentPageCotizaciones === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                            <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangeCotizaciones(currentPageCotizaciones + 1)}>⟩</a>
                          </li>
                          <li class={currentPageCotizaciones === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                            <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangeCotizaciones(ultimoNumeroP)}>»</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(cotizaciones)}</div>*/}
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(embarquesSinFiltro)}</div>*/}
                  </TabPane>
                  <TabPane tabId="2">
                    {//Catálogo de Clientes
                      productos.formType === 'Catálogo' && (
                        <Fragment>
                          <Row>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-left margintop10px " >
                              <h4>Catálogo de clientes</h4>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12  margintop10px" >
                              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-left floatrightleft " >
                                <Label>Mostrando clientes</Label>
                                <select name="clienteestado " className="floatleft custom-select" onChange={productos.sClienteEstado}>
                                  <option value="todos" >Todos</option>
                                  <option value="true">Activos</option>
                                  <option value="false">Inactivos</option>
                                </select>
                              </div>
                            </div>
                          </Row>
                          <div>
                          </div>
                          {
                            <Row>
                              {clientes.map(cliente => (
                                <>
                                  {productos.estadoCliente === "todos" && (
                                    <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                      {
                                        <div>
                                          {
                                            cliente.image && <img src={cliente.image} width="100px" alt={cliente.cliente} onClick={() => productos.onClickCliente(cliente.cliente, cliente.id, cliente.activo)} className="cursorpointer" />
                                          }
                                          <h4>{cliente.cliente} </h4>
                                          <h4>{cliente.activo}</h4>
                                        </div>
                                      }
                                    </div>)
                                  }
                                  {productos.estadoCliente === cliente.activo.toString() && (
                                    <div key={cliente.id || cliente.cliente} className="col-lg-3 col-md-6 col-sm-12  margintop20px">
                                      {
                                        <div>
                                          {
                                            cliente.image && <img src={cliente.image} width="100px" alt={cliente.cliente} onClick={() => productos.onClickCliente(cliente.cliente, cliente.id, cliente.activo)} className="cursorpointer" />
                                          }
                                          <h4>{cliente.cliente} </h4>
                                          <h4>{cliente.activo}</h4>
                                        </div>
                                      }
                                    </div>)
                                  }
                                </>))
                              }
                            </Row>
                          }
                        </Fragment>
                      )
                    }
                    {//Catálogo de Productos
                      productos.formType === 'Catálogo - ' + productos.clienteName && (
                        <Fragment>
                          {!productos.mostrarproducto && (
                            <>
                              <Row className={"margintop20px"}>

                                {
                                  <div class={productos.clienteActivo ? "col-lg-7 col-md-7 col-sm-12 col-xs-12 text-left margintopmobil20px" : "col-lg-10 col-md-9 col-sm-12 col-xs-12 text-left margintopmobil20px"} >
                                    <Label><h5>Busqueda por: </h5></Label>
                                    <select className="ml-2" onChange={productos.onSearchBy}>
                                      <option value="número de parte" selected={searchBy === "número de parte" ? true : false}>Número de parte</option>
                                      <option value="descripción" selected={searchBy === "descripción" ? true : false}>Descripción</option>
                                    </select>
                                    <select className=" estadoproductoscombo" onChange={productos.onEstadoProductos}>
                                      <option value="todos" selected={productos.estadoProductos === "todos" ? true : false}>Todos los productos</option>
                                      <option value="activos" selected={productos.estadoProductos === "activos" ? true : false}>Productos Activos</option>
                                      <option value="inactivos" selected={productos.estadoProductos === "inactivos" ? true : false}>Productos Inactivos</option>
                                    </select>
                                    <Input
                                      type="text"
                                      placeholder={"Búsqueda por " + searchBy}
                                      onChange={(e) => setSearch(e.target.value)}
                                      onKeyUp={onSearch}
                                      value={search}
                                    />
                                  </div>}
                                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                  <button class="floatrightleft btn-info cbutton margintop20px" onClick={productos.catalogo} title="Atrás"> <IoIcons.IoMdArrowRoundBack />Atrás </button>
                                </div>
                              </Row>
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left " >
                                <button className="cbutton btn-dark floatright  " title="Recargar página" onClick={() => { productos.fetchProductos(productos.clienteID, searchBy, search, productos.estadoProductos) }}><IoIcons.IoMdRefresh /> Recargar </button>
                              </div>
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                <Table className=" mb-2 scroll ">
                                  <Thead class="thead-secondary">
                                    <Tr>
                                      <Th >Número de parte</Th>
                                      <Th >Número de parte para embarques</Th>
                                      <Th>Descripción</Th>
                                      <Th>Cantidad por año</Th>
                                      <Th>Estatus</Th>
                                      <Th>Usuario de registro </Th>
                                      <Th>Fecha y hora de registro</Th>
                                      <Th className="width30px" > Detalles </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {productos.productos.map((producto, i) => (
                                      <Tr class={(i % 2) !== 0 ? "table-active" : ""}>
                                        <Td className="margintopmobil20px">{producto.numerodeParte}</Td>
                                        <Td className="margintopmobil20px">{producto.numerodeParteSalida}</Td>
                                        <Td className="margintopmobil20px">{producto.descripcion}</Td>
                                        <Td className="margintopmobil20px">{producto.cantidadporAnio}</Td>
                                        <Td className="margintopmobil20px">{producto.activo ? "Activo" : "Inactivo"}</Td>
                                        <Td className="margintopmobil20px">{producto.Reg_Ins_Usuario}</Td>
                                        <Td className="margintopmobil20px">{Moment(producto.createdAt).format("DD/MM/YYYY, h:mm:ss a")}</Td>
                                        <Td>
                                          <button class="btn-info cbutton mt-1 ml-1" onClick={() => productos.onClickProducto(producto)} title="Detalles"> <IoIcons.IoMdList /> </button>
                                        </Td>
                                      </Tr>
                                    ))}
                                  </Tbody>
                                </Table>
                              </div>
                              {productos.totalRecords > 0 && (
                                <>
                                  <div className="mt-3 mb-3">
                                    Página {productos.currentPage}, mostrando del {(productos.recordPerPage * productos.currentPage - productos.recordPerPage) + 1}  al {productos.totalRecords < productos.recordPerPage * productos.currentPage ? productos.totalRecords : productos.recordPerPage * productos.currentPage} de {productos.totalRecords} registros
                                  </div>
                                  <Row>
                                    <div className="col-lg-12 col-md-12 col-sm-12  " >
                                      <div className="floatcenter">
                                        <Pagination
                                          itemClass="page-item" // add it for bootstrap 4
                                          linkClass="page-link" // add it for bootstrap 4                                    
                                          activePage={productos.currentPage}
                                          itemsCountPerPage={productos.recordPerPage}
                                          totalItemsCount={productos.totalRecords}
                                          pageRangeDisplayed={productos.pageRange}
                                          onChange={productos.handlePageChange}
                                        />
                                      </div>
                                    </div>
                                  </Row>
                                </>
                              )}
                            </>
                          )}
                          {productos.mostrarproducto && (
                            <>
                              <div className="textaligmentleft">
                                <Row className="margintop20px ">
                                  {/*<div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                    <button class=" btn-primary cbutton " onClick={productos.editarProducto} title="Editar"> <IoIcons.IoIosCreate />Editar </button>
                                  </div>*/}
                                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <button class="btn-info cbutton floatrightleft" onClick={productos.regresarCliente} title="Atrás"> <IoIcons.IoMdArrowRoundBack />Atrás </button>
                                  </div>
                                </Row>
                                <Row className="margintop20px ">
                                  <div className="col-lg-6 col-md-7 col-sm-12 col-xs-12">
                                    <Table>
                                      <Thead class="thead-secondary">
                                        <Tr>
                                          <Th><h5>Característica</h5></Th>
                                          <Th ><h5>Valor</h5></Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>

                                        <Tr ><Td><h5>Número de parte:</h5></Td><Td> <h5>{productos.formData.numerodeParte}</h5></Td></Tr>
                                        <Tr ><Td><h5>Número de parte para embarques:</h5></Td><Td> <h5>{productos.formData.numerodeParteSalida}</h5></Td></Tr>
                                        <Tr class="table-active"><Td className="minwidth300pxm"><h5>Descripción: </h5></Td><Td> <h5> {productos.formData.descripcion}</h5> </Td></Tr>
                                        {<Tr ><Td><h5>Precio unitario: </h5></Td><Td> <h5> {productos.formData.divisa === "Peso mexicano" || productos.formData.divisa === "Dólar" ? "$" : "€"} {productos.formData.precioUnitario} {productos.formData.divisa === "Peso mexicano" ? " Pesos" : productos.formData.divisa === "Dólar" ? "Dólares" : "Euros"} </h5> </Td></Tr>}
                                        <Tr class="table-active"><Td><h5>Cantidad por año: </h5></Td><Td> <h5>  {productos.formData.cantidadporAnio} pz </h5>  </Td></Tr>
                                        <Tr ><Td><h5>Producto:  </h5></Td><Td> <h5>{productos.formData.activo ? "Activo" : "Inactivo"}</h5>  </Td></Tr>
                                        <Tr class="table-active"><Td><h5>Usuario de registro:  </h5></Td><Td> <h5> {productos.formData.Reg_Ins_Usuario}</h5>   </Td></Tr>
                                        <Tr ><Td><h5>Fecha de registro: </h5></Td><Td> <h5> {Moment(productos.formData.createdAt).format("DD/MM/YYYY, h:mm:ss a")}</h5> </Td></Tr>
                                        <Tr class="table-active"><Td><h5>Usuario de última actualización: </h5></Td><Td> <h5> {productos.formData.Reg_Mod_Usuario}</h5></Td></Tr>
                                        <Tr ><Td><h5>Fecha de última actualización: </h5></Td><Td> <h5> {productos.formData.updatedAt !== productos.formData.createdAt ? Moment(productos.formData.updatedAt).format("DD/MM/YYYY, h:mm:ss a") : ""}</h5> </Td></Tr>
                                        <Tr class="table-active"><Td><Label><h5>Archivo:</h5></Label> </Td><Td> <ol tipe="1" start="1" >
                                          {productos.formData.documentodeEspecificaciones && (<li><a href={productos.formData.documentodeEspecificacionesurl} >{productos.formData.documentodeEspecificaciones + ' '}</a></li>)}
                                          {productos.formData.documento1 && (<li><a href={productos.formData.documento1url} >{productos.formData.documento1 + ' '}</a></li>)}
                                          {productos.formData.documento2 && (<li><a href={productos.formData.documento2url} >{productos.formData.documento2 + ' '}</a></li>)}
                                          {productos.formData.documento3 && (<li><a href={productos.formData.documento3url} >{productos.formData.documento3 + ' '}</a></li>)}
                                          {productos.formData.documento4 && (<li><a href={productos.formData.documento4url} >{productos.formData.documento4 + ' '}</a></li>)}
                                          {productos.formData.documento5 && (<li><a href={productos.formData.documento5url} >{productos.formData.documento5 + ' '}</a></li>)}
                                          {productos.formData.documento6 && (<li><a href={productos.formData.documento6url} >{productos.formData.documento6 + ' '}</a></li>)}
                                          {productos.formData.documento7 && (<li><a href={productos.formData.documento7url} >{productos.formData.documento7 + ' '}</a></li>)}
                                          {productos.formData.documento8 && (<li><a href={productos.formData.documento8url} >{productos.formData.documento8 + ' '}</a></li>)}
                                          {productos.formData.documento9 && (<li><a href={productos.formData.documento9url} >{productos.formData.documento9 + ' '}</a></li>)}
                                        </ol></Td></Tr>
                                      </Tbody>
                                    </Table>
                                  </div>
                                  <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12 margintop20px ">
                                    <Carousel
                                      activeIndex={productos.activeIndex}
                                      next={productos.next}
                                      previous={productos.previous}
                                    >
                                      <CarouselIndicators items={productos.items} activeIndex={productos.activeIndex} onClickHandler={productos.goToIndex} />
                                      {productos.slides}
                                      <CarouselControl direction="prev" directionText="Previous" onClickHandler={productos.previous} />
                                      <CarouselControl direction="next" directionText="Next" onClickHandler={productos.next} />
                                    </Carousel>
                                  </div>
                                </Row>
                              </div>
                            </>
                          )}
                        </Fragment>
                      )
                    }
                  </TabPane>
                  <TabPane tabId="3">
                    <>
                      {tituloTab !== "Detalle de cotización" && (
                        <h5 className='font-weight-bold'>Product Information (Sales) {editar ? "-" + formData.quoteNumber : ""}</h5>
                      )}
                      {tituloTab === "Detalle de cotización" && (
                        <>
                          <Row>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop10px">
                              <button class="btn-primary cbutton floatleft" title="Editar" onClick={() => clicEditar(formData)}> <IoIcons.IoIosCreate />Editar </button>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop10px">
                              <button class="btn-info cbutton floatrightleft" title="Regresar" onClick={cancelarCotizacion}> <IoIcons.IoMdArrowRoundBack />Regresar </button>
                            </div>
                          </Row>
                          <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px">
                              <h5 className='font-weight-bold'>Product Information (Sales) - {formData.quoteNumber}</h5>
                            </div>
                          </Row>
                        </>
                      )}
                      <Row>
                        <div class={editar ? "col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px" : "col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px"}  >
                          <Label className={(faltanDatos === true && (formData.date === '' || !formData.date)) ? "floatleft fcolorred" : "floatleft"}>Date*: {formData.date} </Label>
                          <Input name="date"
                            type="date"
                            onChange={onChanges}
                            value={formData.date}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.generator) ? "floatleft fcolorred" : "floatleft"}>Generator*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="generator"
                            onChange={onChanges}
                            value={formData.generator}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        {editar && (
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px"  >
                            <Label className={(faltanDatos === true && formData.status === "") ? "floatleft fcolorred" : "floatleft"}>Status*:  {(formData.documentoAceptacion) && (<a className="floatright ml-2 backcolorlgray" href={archivo} >{formData.documentoAceptacion}</a>)}</Label>
                            <select name="status" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : false} >
                              {statusOriginal === "Created" && (<option value="Created" selected={formData.status === "Created" ? true : false}>Created </option>)}
                              {((permisoAutorizar && (statusOriginal === "Created" || statusOriginal === "Rejected")) || statusOriginal === "Authorized") && <option value="Authorized" selected={formData.status === "Authorized" ? true : false}>Authorized </option>}
                              {(statusOriginal === "Authorized" || statusOriginal === "Send") && <option value="Send" selected={formData.status === "Send" ? true : false}>Send </option>}
                              {(statusOriginal === "Send" || statusOriginal === "Accepted") && <option value="Accepted" selected={formData.status === "Accepted" ? true : false}>Accepted </option>}
                              <option value="Rejected" selected={formData.status === "Rejected" ? true : false}>Rejected </option>
                            </select>
                          </div>
                        )}
                        <div class={editar ? "col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " : "col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px "} >
                          <Label className={(faltanDatos === true && !formData.revision) ? "floatleft fcolorred" : "floatleft"}>Revision*: </Label>
                          <select name="revision" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          >
                            <option value="" selected={formData.revision === "" ? true : false}> {editar ? "---" : "Choose an option"} </option>
                            <option value="A" selected={formData.revision === "A" ? true : false}>A </option>
                            <option value="B" selected={formData.revision === "B" ? true : false}>B </option>
                            <option value="C" selected={formData.revision === "C" ? true : false}>C </option>
                            <option value="D" selected={formData.revision === "D" ? true : false}>D </option>
                            <option value="E" selected={formData.revision === "E" ? true : false}>E </option>
                            <option value="F" selected={formData.revision === "F" ? true : false}>F </option>
                            <option value="G" selected={formData.revision === "G" ? true : false}>G </option>
                            <option value="H" selected={formData.revision === "H" ? true : false}>H </option>
                            <option value="I" selected={formData.revision === "I" ? true : false}>I </option>
                            <option value="J" selected={formData.revision === "J" ? true : false}>J </option>
                            <option value="K" selected={formData.revision === "K" ? true : false}>K </option>
                          </select>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.processEngineering) ? "floatleft fcolorred" : "floatleft"}>Process*: </Label>
                          <select name="processEngineering" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                            <option value="Both" selected={formData.processEngineering === "Both" ? true : false}>Both </option>
                            <option value="Painting Tool" selected={formData.processEngineering === "Painting Tool" ? true : false}>Painting Tool </option>
                            <option value="Plating Tool" selected={formData.processEngineering === "Plating Tool" ? true : false}>Plating Tool </option>
                          </select>
                        </div>
                        {formData.processEngineering !== 'Painting Tool' && (
                          <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12  margintop20px " >
                            <Label className={(faltanDatos === true && !formData.platingProcess) ? "floatleft fcolorred" : "floatleft"}> Plating process*: </Label>
                            <select name="platingProcess" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                              <option value="" selected={formData.platingProcess === "" ? true : false}> Choose an option </option>
                              <option value="Zinc plating" selected={formData.platingProcess === "Zinc plating" ? true : false}>Zinc plating </option>
                              <option value="Zinc Nickel Plating" selected={formData.platingProcess === "Zinc Nickel Plating" ? true : false}>Zinc Nickel Plating</option>
                              <option value="Zinc Phosphate" selected={formData.platingProcess === "Zinc Phosphate" ? true : false}>Zinc Phosphate </option>
                              <option value="Nickel Plating" selected={formData.platingProcess === "Nickel Plating" ? true : false}>Nickel Plating </option>
                            </select>
                          </div>
                        )}
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.cliente) ? "floatleft fcolorred" : "floatleft"}>Direct customer*:{/*clienteID + " " + cliente*/} </Label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <button class="cbuttonS floatleft"
                                title={editarCliente === false ? "Otro cliente" : "Lista de clientes"}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                onClick={() => setEditarCliente(!editarCliente)}>

                                {editarCliente === false && (<IoIcons.IoIosCreate />)}
                                {editarCliente === true && (<IoIcons.IoIosList />)}
                              </button>
                            </div>
                            {editarCliente === false && (
                              <select name="cliente" className="floatleft custom-select" onChange={onChangesClientes}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                                <option className="" value="">Choose a customer </option>
                                {clientes.map(cliente => (
                                  <>
                                    {cliente.activo && (
                                      <option className="" value={cliente.id} selected={formData.cliente === cliente.cliente ? true : false} >{cliente.cliente}</option>
                                    )}
                                  </>
                                ))}
                              </select>
                            )}
                            {editarCliente === true && (
                              <Input name="cliente"
                                onChange={onChanges}
                                value={formData.cliente}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            )}
                          </div>
                        </div>
                        <div class={formData.processEngineering === "Painting Tool" ? "col-lg-6 col-md-6 col-sm-6 col-xs-12 margintop20px " : "col-lg-3 col-md-3 col-sm-12 col-xs-12 margintop20px "} >
                          <Label className={(faltanDatos === true && !formData.address) ? "floatleft fcolorred" : "floatleft"}>address*: </Label>
                          <Input
                            type="textarea"
                            name="address"
                            onChange={onChanges}
                            value={formData.address}
                            rows="1"
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>

                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.colonia) ? "floatleft fcolorred" : "floatleft"}>District*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="colonia"
                            onChange={onChanges}
                            value={formData.colonia}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.ciudad) ? "floatleft fcolorred" : "floatleft"}>City*: </Label>
                          <Input
                            name="ciudad"
                            onChange={onChanges}
                            value={formData.ciudad}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.estado) ? "floatleft fcolorred" : "floatleft"}>State*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="estado"
                            onChange={onChanges}
                            value={formData.estado}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.pais) ? "floatleft fcolorred" : "floatleft"}>Country*: </Label>
                          <Input
                            name="pais"
                            onChange={onChanges}
                            value={formData.pais}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.codigoPostal) ? "floatleft fcolorred" : "floatleft"}>ZIP Code*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="codigoPostal"
                            onChange={onChanges}
                            value={formData.codigoPostal}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.telefono) ? "floatleft fcolorred" : "floatleft"}>Desk*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="telefono"
                            onChange={onChanges}
                            value={formData.telefono}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.correo) ? "floatleft fcolorred" : "floatleft"}>Email*: </Label>
                          <Input
                            name="correo"
                            onChange={onChanges}
                            value={formData.correo}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.requestor) ? "floatleft fcolorred" : "floatleft"}>Requestor*: </Label>
                          {editarCliente === false && (
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <button class="cbuttonS floatleft"
                                  title={editarContacto === false ? "Otro contacto" : "Lista de contactos"}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                  onClick={() => setEditarContacto(!editarContacto)}>

                                  {editarContacto === false && (<IoIcons.IoIosCreate />)}
                                  {editarContacto === true && (<IoIcons.IoIosList />)}
                                </button>
                              </div>
                              {editarContacto === false && (
                                <select name="requestor" className="floatleft custom-select" onChange={onChangesRequestor}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                                  <option className="" value="">Choose a requestor </option>
                                  {requestors.map(requestor => (
                                    <>
                                      <option className="" value={requestor.requestor} selected={formData.requestor === requestor.requestor ? true : false} >{requestor.requestor}</option>
                                    </>
                                  ))}
                                </select>
                              )}
                              {editarContacto === true && (
                                <Input name="requestor"
                                  onChange={onChanges}
                                  value={formData.requestor}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                />
                              )}
                            </div>
                          )}
                          {editarCliente === true && (
                            <Input name="requestor"
                              onChange={onChanges}
                              value={formData.requestor}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          )}
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.desk) ? "floatleft fcolorred" : "floatleft"}>Requestor Desk*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="desk"
                            onChange={onChanges}
                            value={formData.desk}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={"floatleft"}>Mobile: </Label>
                          <Input
                            name="mobile"
                            onChange={onChanges}
                            value={formData.mobile}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class={"col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px"} >
                          <Label className={(faltanDatos === true && !formData.position) ? "floatleft fcolorred" : "floatleft"}>Position*: </Label>
                          <Input
                            name="position"
                            onChange={onChanges}
                            value={formData.position}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.email) ? "floatleft fcolorred" : "floatleft"}>Requestor Email*: </Label>
                          <Input
                            name="email"
                            onChange={onChanges}
                            value={formData.email}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.divisa) ? "floatleft fcolorred" : "floatleft"}>Currency*: </Label>
                          <select name="divisa" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                            <option value="Dólar" selected={formData.divisa === "Dólar" ? true : false}>Dólar </option>
                            <option value="Peso mexicano" selected={formData.divisa === "Peso mexicano" ? true : false}>Peso mexicano</option>
                            <option value="Euro" selected={formData.divisa === "Euro" ? true : false}>Euro</option>
                          </select>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.automotive) ? "floatleft fcolorred" : "floatleft"}>Automotive*: </Label>
                          <select name="automotive" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                            <option value="" selected={formData.automotive === "" ? true : false}> --- </option>
                            <option className="" selected={formData.automotive === "Yes" ? true : false} value="Yes">Yes </option>
                            <option className="" selected={formData.automotive === "No" ? true : false} value="No">No </option>
                          </select>
                        </div>
                        {!formData.clienteID && (
                          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px">
                            <FormGroup >
                              <Label className="floatleft ">Logo del cliente</Label>
                              <Input
                                name="image"
                                type="file"
                                accept=".gif,.jpg,.jpeg,.png,.jfif"
                                onChange={onChangelogodoc}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                              {formData.imageurl && (<img src={formData.imageurl} alt="logo del cliente" width="100px" title={formData.image} />)}
                            </FormGroup>
                          </div>
                        )}
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px">
                          <FormGroup >
                            <Label className="floatleft ">
                              {!formData.documento1 ? "Dibujo del producto en pdf" : <a href={formData.documento1url} >{formData.documento1}</a>}
                              <button class="btn-warning  mt-1 ml-2" onClick={() => setDocumenton(documenton + 1)} title="Agregar documento" hidden={hEditarCotizacion}> Agregar pdf </button>
                            </Label>
                            <Input
                              name="documento1"
                              type="file"
                              accept=".pdf"
                              onChange={onChangelogodoc}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </FormGroup>
                        </div>

                        {documenton > 1 && (
                          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                            <FormGroup >
                              <Label className="floatleft ">{!formData.documento2 ? "Documento pdf 1" : <a href={formData.documento2url} >{formData.documento2}</a>}</Label>
                              <Input
                                name="documento2"
                                type="file"
                                onChange={onChangelogodoc}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </FormGroup>
                          </div>
                        )
                        }

                        {documenton > 2 && (
                          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                            <FormGroup >
                              <Label className="floatleft ">{!formData.documento3 ? "Documento pdf 2" : <a href={formData.documento3url} >{formData.documento3}</a>}</Label>
                              <Input
                                name="documento3"
                                type="file"
                                onChange={onChangelogodoc}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </FormGroup>
                          </div>
                        )
                        }
                        {documenton > 3 && (
                          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                            <FormGroup >
                              <Label className="floatleft ">{!formData.documento4 ? "Documento pdf 3" : <a href={formData.documento4url} >{formData.documento4}</a>}</Label>
                              <Input
                                name="documento4"
                                type="file"
                                onChange={onChangelogodoc}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </FormGroup>
                          </div>
                        )
                        }
                        {documenton > 4 && (
                          <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                            <FormGroup >
                              <Label className="floatleft ">{!formData.documento5 ? "Documento pdf 4" : <a href={formData.documento5url} >{formData.documento5}</a>}</Label>
                              <Input
                                name="documento5"
                                type="file"
                                onChange={onChangelogodoc}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </FormGroup>
                          </div>
                        )
                        }
                        {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px ">
                          {JSON.stringify(formData)}
                      </div>*/}

                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">OEM: </Label>
                          <Input
                            name="OEM"
                            onChange={onChanges}
                            value={formData.OEM}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">RFQ Number:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="RFQNumber"
                            onChange={onChanges}
                            value={formData.RFQNumber}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.numerodeParte) ? "floatleft fcolorred" : "floatleft"}>Part Number*: </Label>
                          <Input
                            name="numerodeParte"
                            onChange={onChanges}
                            value={formData.numerodeParte}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Description: </Label>
                          <Input
                            name="descripcion"
                            onChange={onChanges}
                            value={formData.descripcion}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Nick name: </Label>
                          <Input
                            name="nickName"
                            onChange={onChanges}
                            value={formData.nickName}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.annualVolume) ? "floatleft fcolorred" : "floatleft"}>Annual Volume*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="annualVolume"
                            onChange={onChangesNumeros}
                            value={formData.annualVolume}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className="floatleft">Packig type : </Label>
                          <Input
                            name="packigType"
                            onChange={onChanges}
                            value={formData.packigType}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            placeholder="Bulk, Skid, container, etc"
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Packing instruction number: </Label>
                          <Input
                            name="packingINumber"
                            onChange={onChanges}
                            value={formData.packingINumber}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Packing instruction revision: </Label>
                          <Input
                            name="packingIRevision"
                            onChange={onChanges}
                            value={formData.packingIRevision}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.packingSource) ? "floatleft fcolorred" : "floatleft"}>Packing source*:{/*clienteID + " " + cliente*/} </Label>
                          <Input
                            name="packingSource"
                            onChange={onChanges}
                            value={formData.packingSource}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            placeholder="Customer, Boon Tec, etc"
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.sampleReceived) ? "floatleft fcolorred" : "floatleft"}>Sample received*: </Label>
                          <select name="sampleReceived" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                            <option value="" selected={formData.sampleReceived === "" ? true : false}>Choose an option</option>
                            <option className="" selected={formData.sampleReceived === "Yes" ? true : false} value="Yes">Yes </option>
                            <option className="" selected={formData.sampleReceived === "No" ? true : false} value="No">No </option>
                          </select>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.drawingSProvided) ? "floatleft fcolorred" : "floatleft"}>Drawing specs provided*: </Label>
                          <select name="drawingSProvided" className="floatleft custom-select" onChange={onChanges}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                            <option value="" selected={formData.drawingSProvided === "" ? true : false}>Choose an option</option>
                            <option className="" selected={formData.drawingSProvided === "Yes" ? true : false} value="Yes">Yes </option>
                            <option className="" selected={formData.drawingSProvided === "No" ? true : false} value="No">No </option>
                          </select>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Drawing Revision: </Label>
                          <Input
                            name="drawingRevision"
                            onChange={onChanges}
                            value={formData.drawingRevision}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        {formData.processEngineering !== 'Plating Tool' && (
                          <>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                              <Label className="floatleft">Paint Thickness:{/*clienteID + " " + cliente*/} </Label>
                              <Input
                                name="paintThickness"
                                onChange={onChanges}
                                value={formData.paintThickness}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                              <Label className="floatleft">Paint Spec: </Label>
                              <Input
                                name="paintSpec"
                                onChange={onChanges}
                                value={formData.paintSpec}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            </div>
                          </>
                        )}
                        {(formData.processEngineering !== 'Painting Tool' && formData.platingProcess) && (
                          <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">{formData.platingProcess + ":"}  </Label>
                            <Input
                              name="zincPlating"
                              onChange={onChanges}
                              value={formData.zincPlating}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>)}
                      </Row>
                      <Row>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Chromate Color: </Label>
                          <Input
                            name="chromateColor"
                            onChange={onChanges}
                            value={formData.chromateColor}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Previous process:{/*clienteID + " " + cliente*/} </Label>

                          <div class="input-group">
                            <div class="input-group-prepend">
                              <button class="cbuttonS floatleft"
                                title={editarPprocess === false ? "Otro proceso" : "Lista de procesos"}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                onClick={() => setEditarPprocess(!editarPprocess)}>

                                {editarPprocess === false && (<IoIcons.IoIosCreate />)}
                                {editarPprocess === true && (<IoIcons.IoIosList />)}
                              </button>
                            </div>
                            {editarPprocess === false && (
                              <select name="previousProcess" className="floatleft custom-select" onChange={onChanges}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                                <option className="" value="">{formData.previousProcess ? formData.previousProcess : ""} </option>
                                <option className="" value={"Deburring"} selected={formData.previousProcess === "Deburring" ? true : false} >Deburring</option>
                                <option className="" value={"Cleaning"} selected={formData.previousProcess === "Cleaning" ? true : false} >Cleaning</option>
                                <option className="" value={"Manufacture"} selected={formData.previousProcess === "Manufacture" ? true : false} >Manufacture</option>
                              </select>
                            )}
                            {editarPprocess === true && (
                              <Input name="previousProcess"
                                onChange={onChanges}
                                value={formData.previousProcess}
                                disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              />
                            )}
                          </div>

                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className="floatleft">White corrosion Requirement: </Label>
                          <Input
                            name="whiteCRequirement"
                            onChange={onChanges}
                            value={formData.whiteCRequirement}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Red Corrosion Requirement: </Label>
                          <Input
                            name="RedCRequiremen"
                            onChange={onChanges}
                            value={formData.RedCRequiremen}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">SOP: </Label>
                          <Input name="SOP"
                            type="date"
                            onChange={onChanges}
                            value={formData.SOP}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">EOP: </Label>
                          <Input name="EOP"
                            type="date"
                            onChange={onChanges}
                            value={formData.EOP}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}

                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.area) ? "floatleft fcolorred" : "floatleft"}>Area (SQF)*: </Label>
                          <div class="input-group">
                            <Input name="area"
                              onChange={onChangesNumeros}
                              value={formData.area}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                            <div class="input-group-prepend">
                              <button class="cbuttonS floatleft" title="Calculate area" onClick={toggle}> <IoIcons.IoIosCalculator /> </button>
                            </div>
                          </div>
                        </div>
                        {/*<div class="col-lg-2 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">SQFT: </Label>
                            <Input name="SQFT"
                              onChange={onChanges}
                              value={formData.SQFT}
                            />
                          </div>*/}
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.pieceWeight) ? "floatleft fcolorred" : "floatleft"}>Piece weight (Kilograms)*: </Label>
                          <Input name="pieceWeight"
                            onChange={onChangesNumeros}
                            value={formData.pieceWeight}
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px " >
                          <Label className="floatleft">Print notes: </Label>
                          <Input
                            type="textarea"
                            name="printNotes"
                            onChange={onChanges}
                            value={formData.printNotes}
                            rows="1"
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px " >
                          <Label className="floatleft">Sales notes: </Label>
                          <Input
                            type="textarea"
                            name="salesNotes"
                            onChange={onChanges}
                            value={formData.salesNotes}
                            rows="1"
                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                          />
                        </div>
                      </Row>

                      <Row>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6   margintop20px " >
                          <h5 className='font-weight-bold floatright'>Process Engineering Info</h5>
                        </div>
                      </Row>
                      {(formData.processEngineering === "Both" || formData.processEngineering === "Painting Tool") && (
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12   margintop20px "  >
                            <h5 className='font-weight-bold floatleft'>Painting Tool</h5>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.hangingTool) ? "floatleft fcolorred" : "floatleft"}>Hanging tool*: </Label>
                            <Input name="hangingTool"
                              onChange={onChanges}
                              value={formData.hangingTool}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                              placeholder="hook, clip, triangle, other"
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.newToolRequired) ? "floatleft fcolorred" : "floatleft"}>New tool fabrication Required?*: </Label>
                            <select name="newToolRequired" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                              <option value="" selected={formData.newToolRequired === "" ? true : false}>Choose an option</option>
                              <option className="" value="Yes" selected={formData.newToolRequired === "Yes" ? true : false}>Yes </option>
                              <option className="" value="No" selected={formData.newToolRequired === "No" ? true : false} >No </option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">Cost of new Tool fabrication: </Label>
                            <Input
                              name="costOfNewTool"
                              onChange={onChangesNumeros}
                              value={formData.costOfNewTool}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.asignedToolBar) ? "floatleft fcolorred" : "floatleft"}>Asigned tool bar*:{/*clienteID + " " + cliente*/} </Label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <button class="cbuttonS floatleft"
                                  title={editarAToolBar === false ? "Otro Tool Bar" : "Lista de Tool Bars"}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                  onClick={() => setEditarAToolBar(!editarAToolBar)}>

                                  {editarAToolBar === false && (<IoIcons.IoIosCreate />)}
                                  {editarAToolBar === true && (<IoIcons.IoIosList />)}
                                </button>
                              </div>
                              {editarAToolBar === false && (
                                <select name="asignedToolBar" className="floatleft custom-select" onChange={onChanges}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                                  <option className="" value="">{formData.asignedToolBar ? formData.asignedToolBar : ""} </option>
                                  <option className="" value={"VAMP-01"} selected={formData.asignedToolBar === "VAMP-01" ? true : false} >VAMP-01</option>
                                  <option className="" value={"BRORE-02"} selected={formData.asignedToolBar === "BRORE-02" ? true : false} >BRORE-02</option>
                                  <option className="" value={"KAB-03"} selected={formData.asignedToolBar === "KAB-03" ? true : false} >KAB-03</option>
                                  <option className="" value={"VIKO-01"} selected={formData.asignedToolBar === "VIKO-01" ? true : false} >VIKO-01</option>
                                  <option className="" value={"TR8-02"} selected={formData.asignedToolBar === "TR8-02" ? true : false} >TR8-02</option>
                                  <option className="" value={"TEL-02"} selected={formData.asignedToolBar === "TEL-02" ? true : false} >TEL-02</option>
                                  <option className="" value={"UN-01"} selected={formData.asignedToolBar === "UN-01" ? true : false} >UN-01</option>
                                  <option className="" value={"CLIPT-01"} selected={formData.asignedToolBar === "CLIPT-01" ? true : false} >CLIPT-01</option>
                                  <option className="" value={"HERR-02"} selected={formData.asignedToolBar === "HERR-02" ? true : false} >HERR-02</option>
                                  <option className="" value={"CAVO-01"} selected={formData.asignedToolBar === "CAVO-01" ? true : false} >CAVO-01</option>
                                  <option className="" value={"CLIPC-02"} selected={formData.asignedToolBar === "CLIPC-02" ? true : false} >CLIPC-02</option>
                                  <option className="" value={"VAMP-02"} selected={formData.asignedToolBar === "VAMP-02" ? true : false} >VAMP-02</option>
                                  <option className="" value={"VAMP-03"} selected={formData.asignedToolBar === "VAMP-03" ? true : false} >VAMP-03</option>
                                  <option className="" value={"ODY-02"} selected={formData.asignedToolBar === "ODY-02" ? true : false} >ODY-02</option>
                                  <option className="" value={"ODY-01"} selected={formData.asignedToolBar === "ODY-01" ? true : false} >ODY-01</option>
                                  <option className="" value={"UN-02"} selected={formData.asignedToolBar === "UN-02" ? true : false} >UN-02</option>
                                  <option className="" value={"ORUGA-01"} selected={formData.asignedToolBar === "ORUGA-01" ? true : false} >ORUGA-01</option>
                                  <option className="" value={"CON-01"} selected={formData.asignedToolBar === "CON-01" ? true : false} >CON-01</option>
                                  <option className="" value={"DES-02"} selected={formData.asignedToolBar === "DES-02" ? true : false} >DES-02</option>
                                  <option className="" value={"CLIP-H"} selected={formData.asignedToolBar === "CLIP-H" ? true : false} >CLIP-H</option>
                                  <option className="" value={"CUÑA-02"} selected={formData.asignedToolBar === "CUÑA-02" ? true : false} >CUÑA-02</option>
                                  <option className="" value={"PIS-01"} selected={formData.asignedToolBar === "PIS-01" ? true : false} ></option>
                                </select>
                              )}
                              {editarAToolBar === true && (
                                <Input name="asignedToolBar"
                                  onChange={onChanges}
                                  value={formData.asignedToolBar}
                                  disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                />
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">Asigned voltage:{/*clienteID + " " + cliente*/} </Label>
                            <select name="asignedVoltage" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                              <option value="" selected={formData.asignedVoltage === "" ? true : false}>Choose an option</option>
                              <option className="" value="A" selected={formData.asignedVoltage === "A" ? true : false}>A </option>
                              <option className="" value="B" selected={formData.asignedVoltage === "B" ? true : false} >B </option>
                              <option className="" value="C" selected={formData.asignedVoltage === "C" ? true : false} >C </option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.rackType) ? "floatleft fcolorred" : "floatleft"}>Rack Type*: </Label>
                            <select name="rackType" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                              <option className="" value="">Choose an option </option>
                              <option className="" selected={formData.rackType === "Fixed" ? true : false} value="Fixed">Fixed </option>
                              <option className="" selected={formData.rackType === "movible" ? true : false} value="movible">movible </option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.piecesperBar) ? "floatleft fcolorred" : "floatleft"}>Pieces per Bar*: </Label>
                            <Input
                              name="piecesperBar"
                              onChange={onChangesNumeros}
                              value={formData.piecesperBar}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.barsPerLevel) ? "floatleft fcolorred" : "floatleft"}>Bars per level*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="barsPerLevel"
                              onChange={onChangesNumeros}
                              value={formData.barsPerLevel}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-1 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.levels) ? "floatleft fcolorred" : "floatleft"}>Levels*: </Label>
                            <Input
                              name="levels"
                              onChange={onChangesNumeros}
                              value={formData.levels}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.processSuggestedPrice) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Process Engr. Suggested price*: </Label>
                            <Input
                              name="processSuggestedPrice"
                              onChange={onChangesNumeros}
                              value={formData.processSuggestedPrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.finalSalePrice) ? "floatleft fcolorred" : "floatleft"}>Final sale price*: </Label>
                            <Input
                              name="finalSalePrice"
                              onChange={onChangesNumeros}
                              value={formData.finalSalePrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.piecesPerRack) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Pieces per rack*: </Label>
                            <Input
                              name="piecesPerRack"
                              value={formData.piecesPerRack}
                              onChange={onChangesNumeros}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.weightForRack) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Weight for rack per Engr. Proposal (Kg)*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="weightForRack"
                              value={formData.weightForRack}
                              onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.totalPerRack) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Total Sale per rack (USD)*: </Label>
                            <Input
                              name="totalPerRack"
                              onChange={onChanges}
                              value={formData.totalPerRack}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.toolingCost) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Tooling cost*: </Label>
                            <Input
                              name="toolingCost"
                              onChange={onChanges}
                              value={formData.toolingCost}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.maximumPieces) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Maximum pieces (considering 250SQFT)*: </Label>
                            <Input
                              name="maximumPieces"
                              onChange={onChanges}
                              value={formData.maximumPieces}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Total weight of rack @ 250 SQFT (Kg): </Label>
                            <Input
                              name="totalWeightRack"
                              onChange={onChanges}
                              value={formData.totalWeightRack}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Suggested Rack Sale: </Label>
                            <Input
                              name="suggestedRack"
                              onChange={onChanges}
                              value={formData.suggestedRack}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.finalRackSale) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Final Rack Sale*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="finalRackSale"
                              onChange={onChanges}
                              value={formData.finalRackSale}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Final SQFT price: </Label>
                            <Input
                              name="finalSQFTPrice"
                              onChange={onChanges}
                              value={formData.finalSQFTPrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                        </Row>
                      )}
                      {(formData.processEngineering === "Both" || formData.processEngineering === "Plating Tool") && (
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12   margintop20px "  >
                            <h5 className='font-weight-bold floatleft'>Plating Tool</h5>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.typeOfProcess) ? "floatleft fcolorred" : "floatleft"}>Type of Process*: </Label>
                            <select name="typeOfProcess" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                              <option className="" value="">Choose an option </option>
                              <option className="" selected={formData.typeOfProcess === "Barrel" ? true : false} value="Barrel">Barrel </option>
                              <option className="" selected={formData.typeOfProcess === "Rack" ? true : false} value="Rack">Rack </option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.hangingToolP) ? "floatleft fcolorred" : "floatleft"}>Hanging Tool*:{/*clienteID + " " + cliente*/} </Label>
                            <select name="hangingToolP" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}  >
                              <option className="" value="">Choose an option </option>
                              <option className="" selected={formData.hangingToolP === "G" ? true : false} value="G">G (Hook)</option>
                              <option className="" selected={formData.hangingToolP === "C" ? true : false} value="C">C (Clip)</option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.firstRowDistance) ? "floatleft fcolorred" : "floatleft"}>First row Distance*: </Label>
                            <select name="firstRowDistance" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                              <option className="" value="">Choose an option </option>
                              <option selected={formData.firstRowDistance === "A" ? true : false} className="" value="A">A (High)</option>
                              <option selected={formData.firstRowDistance === "B" ? true : false} className="" value="B">B (Low)</option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.tPiecesPROB) ? "floatleft fcolorred" : "floatleft"}>Total pieces per rack or barrel*: </Label>
                            <Input
                              name="tPiecesPROB"
                              onChange={onChangesNumeros}
                              value={formData.tPiecesPROB}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.pPerlevel) ? "floatleft fcolorred" : "floatleft"}>Pices Per Level*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="pPerlevel"
                              onChange={onChangesNumeros}
                              value={formData.pPerlevel}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.lPerRack) ? "floatleft fcolorred" : "floatleft"}>Levels per rack*: </Label>
                            <Input
                              name="lPerRack"
                              onChange={onChangesNumeros}
                              value={formData.lPerRack}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.toolAngle) ? "floatleft fcolorred" : "floatleft"}>Tool Angle*: </Label>
                            <select name="toolAngle" className="floatleft custom-select" onChange={onChanges}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} >
                              <option className="" value="">Choose an option </option>
                              <option selected={formData.toolAngle === "Cero" ? true : false} className="" value="Cero">Cero</option>
                              <option selected={formData.toolAngle === "Forty five" ? true : false} className="" value="Forty five">Forty five</option>
                              <option selected={formData.toolAngle === "Ninety" ? true : false} className="" value="Ninety">Ninety</option>
                              <option selected={formData.toolAngle === "One hundred and eighty" ? true : false} className="" value="One hundred and eighty">One hundred and eighty</option>
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.DCVoltageA) ? "floatleft fcolorred" : "floatleft"}>DC Voltage Applied*: </Label>
                            <Input
                              name="DCVoltageA"
                              onChange={onChanges}
                              value={formData.DCVoltageA}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.DCAmperageA) ? "floatleft fcolorred" : "floatleft"}>DC Amperage Applied*: </Label>
                            <Input
                              name="DCAmperageA"
                              onChange={onChanges}
                              value={formData.DCAmperageA}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">Residence time on Zinc: </Label>
                            <Input
                              name="residenceTimeZinc"
                              onChange={onChanges}
                              value={formData.residenceTimeZinc}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft">Residence time on Chromate:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="residenceTimeChromate"
                              onChange={onChanges}
                              value={formData.residenceTimeChromate}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Process Engr. Suggested price: </Label>
                            <Input
                              name="processPSuggestedPrice"
                              onChange={onChangesNumeros}
                              value={formData.processPSuggestedPrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.finalPSalePrice) ? "floatleft fcolorred" : "floatleft"}>Final sale price*: </Label>
                            <Input
                              name="finalPSalePrice"
                              onChange={onChangesNumeros}
                              value={formData.finalPSalePrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.toolingCostP) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Tooling cost*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="toolingCostP"
                              onChange={onChanges}
                              value={formData.toolingCostP}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12   margintop20px "  >
                            <Label className={(faltanDatos === true && !formData.SQTFPerBR) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>SQTF per Barrel / Rack*: </Label>
                            <Input
                              name="SQTFPerBR"
                              onChange={onChanges}
                              value={formData.SQTFPerBR}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.loadWeightK) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Load weight (Kilograms)*: </Label>
                            <Input
                              name="loadWeightK"
                              onChange={onChanges}
                              value={formData.loadWeightK}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Suggested Rack / Barrel Sale(sugerido): </Label>
                            <Input
                              name="suggestedRBSale"
                              onChange={onChanges}
                              value={formData.suggestedRBSale}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className={(faltanDatos === true && !formData.finalRBSale) ? "floatleft fcolorred" : "floatleft fcolord6e2e9"}>Final Rack / Barrel Sale*:{/*clienteID + " " + cliente*/} </Label>
                            <Input
                              name="finalRBSale"
                              onChange={onChanges}
                              value={formData.finalRBSale}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 margintop20px " >
                            <Label className="floatleft fcolord6e2e9">Final SQFT price: </Label>
                            <Input
                              name="finalPSQFTPrice"
                              value={formData.finalPSQFTPrice}
                              disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                            />
                          </div>
                        </Row>
                      )}
                      <Row>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12   margintop20px "  >
                          <h5 className='font-weight-bold'>Quality Info</h5>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12   margintop20px "  >
                          <Label className={(faltanDatos === true && !formData.PPAPLevel) ? "floatleft " : "floatleft"}>PPAP Level: </Label>
                          <Input
                            name="PPAPLevel"
                            onChange={onChanges}
                            value={formData.PPAPLevel}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.aPPAPSubmission) ? "floatleft " : "floatleft"}>Annual PPAP Submission: </Label>
                          <Input
                            name="aPPAPSubmission"
                            onChange={onChanges}
                            value={formData.aPPAPSubmission}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className={(faltanDatos === true && !formData.aSpecRessumission) ? "floatleft " : "floatleft"}>Annual spec ressumission: </Label>
                          <Input name="aSpecRessumission"
                            onChange={onChanges}
                            value={formData.aSpecRessumission}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                          <Label className="floatleft">Does this product can be clasified in an exsisting familly?: </Label>
                          <Input name="exsistingFamilly"
                            onChange={onChanges}
                            value={formData.exsistingFamilly}
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px " >
                          <Label className="floatleft">Critical areas and points to consider by quality: </Label>
                          <Input name="pointsToQuality"
                            type="textarea"
                            onChange={onChanges}
                            value={formData.pointsToQuality}
                            rows="1"
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2" >
                          <Label className="floatleft margintop20px">Quality Notes: </Label>
                          <Input name="qualityNotes"
                            type="textarea"
                            onChange={onChanges}
                            value={formData.qualityNotes}
                            rows="1"
                            disabled={tituloTab === "Detalle de cotización" ? true : false}
                          />
                        </div>
                      </Row>
                      {tituloTab !== "Detalle de cotización" && (
                        <Row>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Button className="floatright" onClick={cancelarCotizacion} color="danger" >
                              Cancelar
                            </Button>
                            <Button className="floatright" onClick={manageCotizacion} disabled={isDisabled} color="primary" >
                              Guardar
                            </Button>
                          </div>
                        </Row>
                      )}
                      {(tituloTab === "Detalle de cotización" && permisoAutorizar === true && (formData.autorizado !== true || formData.status === "Rejected")) && (
                        <Row>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px mb-2">
                            <button class="btn-primary cbutton floatright" title="Autorizar" onClick={() => clicAutorizar()}> <IoIcons.IoIosCreate />Autorizar cotización </button>
                          </div>
                        </Row>
                      )}

                      {/*"QUBTI" + Moment(formData.date).format("MMDDYY") + "-"*/}
                      {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(formData)}</div>*/}
                    </>
                    <Modal isOpen={modal} toggle={toggle}>
                      <ModalHeader toggle={toggle}>Calcular área{/*Calculate area*/}</ModalHeader>
                      <ModalBody>
                        Favor de introducir las medidas de la pieza de mayor a menor tamaño.
                        {/*Enter the measurements of the piece from the largest area to the smallest, please.*/}
                        <Row >
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px ">
                            <Label>Medidas en*:{/*Measurements entered in*:*/} </Label>
                            <select name="medidaIngresadaEn" className=" custom-select" disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion} onChange={(e) => onChangeMedidaEn(e)}>
                              <option value="Centímetros" selected={medidaIngresadaEn === "Centímetros" ? true : false}>Centímetros{/*Milimeters*/}</option>
                              <option value="Milímetros" selected={medidaIngresadaEn === "Milímetros" ? true : false}>Milímetros{/*Milimeters*/}</option>
                              <option value="Pulgadas" selected={medidaIngresadaEn === "Pulgadas" ? true : false}>Pulgadas{/*Inches*/}</option>
                            </select>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px  scroll">
                            <Table className=" ">
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th  >#</Th>
                                  <Th className=" minwidth80px">Alto*{/*Height**/}</Th>
                                  <Th className=" minwidth80px">Ancho*{/*Width**/}</Th>
                                  <Th className=" minwidth80px">Repeticiones*{/*Width**/}</Th>
                                  <Th className=" minwidth80px">Perímetro*{/*Thickness measurement*/}</Th>
                                  {tituloTab !== "Detalle de cotización" && (<Th className=" minwidth80px">Acciones{/*Actions*/}</Th>)}

                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map((x, i) => {
                                  return (
                                    x.activo === true && (
                                      <Tr class={x.sombreado ? "table-active" : ""} >
                                        <Td>{i + 1}</Td>
                                        <Td className={(x.alto === "" && faltanDatos === true) ? "novalido" : " "}>
                                          <Input name="alto" maxLength={10} value={x.alto} type="text"
                                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                            onChange={e => setInputList(handleInputChangeMedidas(e, i, [...inputList]))} />
                                        </Td>{/*onChange={e => setInputList(handleInputChangeMedidas(e, i, [...inputList]))} */}
                                        <Td className={(x.ancho === "" && faltanDatos === true) ? "novalido" : " "}>
                                          <Input name="ancho" maxLength={10} value={x.ancho} type="text"
                                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                            onChange={e => setInputList(handleInputChangeMedidas(e, i, [...inputList]))} />
                                        </Td>
                                        <Td className={(x.repeticiones === "" && faltanDatos === true) ? "novalido" : " "}>
                                          <select name="repeticiones" className=" custom-select" tabIndex={(1000 * i) + 3}
                                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                            onChange={e => setInputList(handleInputDatos(e, i, [...inputList]))}>
                                            <option value="1" selected={x.repeticiones === 1 ? true : false}>1</option>
                                            <option value="2" selected={x.repeticiones === 2 ? true : false}>2</option>
                                            <option value="3" selected={x.repeticiones === 3 ? true : false}>3</option>
                                            <option value="4" selected={x.repeticiones === 4 ? true : false}>4</option>
                                            <option value="5" selected={x.repeticiones === 5 ? true : false}>5</option>
                                            <option value="6" selected={x.repeticiones === 6 ? true : false}>6</option>
                                            <option value="7" selected={x.repeticiones === 7 ? true : false}>7</option>
                                            <option value="8" selected={x.repeticiones === 8 ? true : false}>8</option>
                                            <option value="9" selected={x.repeticiones === 9 ? true : false}>9</option>
                                            <option value="10" selected={x.repeticiones === 10 ? true : false}>10</option>
                                          </select>
                                        </Td>
                                        <Td className={(x.medidaGrosor === "" && faltanDatos === true) ? "novalido" : " "}>
                                          <select name="medidaGrosor" className=" custom-select" tabIndex={(1000 * i) + 4}
                                            disabled={tituloTab === "Detalle de cotización" ? true : hEditarCotizacion}
                                            onChange={e => setInputList(handleInputDatos(e, i, [...inputList]))}>
                                            <option value={false} selected={x.medidaGrosor === false ? true : false}>No</option>
                                            <option value={true} selected={x.medidaGrosor === true ? true : false}>Sí</option>
                                          </select>
                                        </Td>
                                        {tituloTab !== "Detalle de cotización" && (
                                          <Td>
                                            {(i < inputList.length - 1) && (
                                              <button
                                                tabIndex={(1000 * i) + 5}
                                                class="btn-danger cbutton "
                                                title="Eliminar registro"
                                                onClick={() => setInputList(handleRemoveClick(i, [...inputList]))}
                                              ><IoIcons.IoMdClose />
                                              </button>
                                            )}
                                          </Td>
                                        )}
                                      </Tr>
                                    )
                                  );
                                })}
                              </Tbody>
                            </Table>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px  ">
                            <Label> Área en pies cuadrados: {formData.area}</Label>
                          </div>
                          {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputListMod)}</div>*/}
                        </Row>
                      </ModalBody>
                      {tituloTab !== "Detalle de cotización" && (
                        <ModalFooter>
                          <Button color="primary" onClick={toggle} >Aceptar</Button>
                          <Button color="danger" onClick={cancelarMedidas}>Cancelar</Button>
                        </ModalFooter>
                      )}
                    </Modal>
                    <Modal isOpen={modal2} toggle={toggle2}>
                      <ModalHeader toggle={toggle2}>Estatus aceptado</ModalHeader>
                      <ModalBody>
                        Al actualizar el estatus de la cotización a aceptado, se tiene que adjuntar el documento de aceptación.
                        <Row >
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                            <Alert color={colorM} isOpen={aVisibleM} toggle={onDismiss}>
                              {mensajeAlertM}
                            </Alert>
                          </div>
                          {cargandoM === true && (
                            <Row>
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  " >
                                <img width="150px" src="assets/img/preloader.gif" />
                              </div>
                            </Row>
                          )}
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px">
                            <FormGroup >
                              <Input
                                name="documentoAceptacion"
                                type="file"
                                onChange={onChangedocumento}
                              />
                              {/*archivo.name && (<li  className="floatleft"><a href={formData.archivo} >{archivo.name }</a></li>)*/}
                            </FormGroup>
                          </div>
                        </Row>
                      </ModalBody>
                      {tituloTab !== "Detalle de cotización" && (
                        <ModalFooter>
                          <Button color="primary" onClick={toggle2} >Aceptar</Button>
                          <Button color="danger" onClick={cancelarModalCotizacion}>Cancelar</Button>
                        </ModalFooter>
                      )}
                    </Modal>
                    <Modal isOpen={modal3} toggle={toggle3}>
                      <ModalHeader toggle={toggle3}>Estatus rechazado</ModalHeader>
                      <ModalBody>
                        Al actualizar el estatus de la cotización a rechazado, se tiene que agregar un comentario con el motivo del rechazo.
                        <Row >
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px  ">
                            <Label className={(!formData.comentariosDeRechazo) ? "floatleft fcolorred" : "floatleft"}>comentario*: </Label>
                            <Input
                              type="textarea"
                              name="comentariosDeRechazo"
                              onChange={onChanges}
                              value={formData.comentariosDeRechazo}
                              rows="3"
                            />
                          </div>
                        </Row>
                      </ModalBody>
                      {formData.comentariosDeRechazo && (
                        <ModalFooter>
                          <Button color="primary" onClick={() => actualizarStatusCotizacion(formData, 2)} >Aceptar</Button>
                          <Button color="danger" onClick={cancelarRechazo}>
                            Cancelar</Button>
                        </ModalFooter>
                      )}
                    </Modal>
                  </TabPane>
                  <TabPane tabId="4" >
                    <div ref={componentRef} >
                      <Row>
                        <img className="imgmarlimp" src="assets/img/Logo/logost.png" />
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px  textaligmentcenter">
                          <h3 class=" textaligmentcenter tbold">Pre Quotation for Coating Services</h3>
                          <h5 class=" tbold margintop60px">CAS Global LLC:  31385 Rangerville Rd. San Benito Texas 78586;  Phone (512) 686-1707</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop40px">
                          <h5 class="floatright margintop-33px tbold">Boon tec International S de RL de CV:</h5>
                          <h5 class="floatright">Norte 2 #14, Fracc. Cd. Industrial, </h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12">
                          <h5 class="floatright margintop-6px">H.Matamoros, Mexico  CP 87499 </h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12">
                          <h5 class="floatright margintop-6px">{"Ph. & Fax 01152 868 8260543"}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12   margintop20px ">
                          <h5 class="floatleft  " >To: {cotizacionImprimir.cliente}</h5>
                          <h5 class="floatright" >Tel:  {cotizacionImprimir.desk}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12">
                          <h5 class="floatleft margintop-6px ml-3">{cotizacionImprimir.requestor}</h5>
                          <h5 class="floatright margintop-6px">Mobile: {cotizacionImprimir.mobile}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12">
                          <h5 class="floatleft margintop-6px ml-3" >{cotizacionImprimir.position}</h5>
                          <h5 class="floatright margintop-6px" >Email: {cotizacionImprimir.email}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <h5 class="textjustify margintop-6px ml-3 width400px" >{cotizacionImprimir.address + "  " +
                            cotizacionImprimir.colonia + " " + cotizacionImprimir.ciudad + " " + cotizacionImprimir.estado + " " +
                            cotizacionImprimir.pais + " " + cotizacionImprimir.codigoPostal}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <h5 class="floatright margintop-6px " >Quotation #: {cotizacionImprimir.quoteNumber}</h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <h5 class="floatright margintop-6px" >Date: {cotizacionImprimir.date}</h5>
                        </div>

                      </Row>
                      <div >
                        <h5 class=" tbold margintop20px floatleft ml-3">{"Quote description & details:"}</h5>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <Table bordered className="margintop20px mb-2  fontsize18px " >
                            <Thead >
                              <Tr>
                                <Th className="minwidth200px  thtableImprimir  fontsize18px textaligmentcenter">
                                  Paint services for part noted below
                                </Th>
                              </Tr>
                            </Thead>
                          </Table>
                        </div>

                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <Table bordered className="margintop-10px mb-2  fontsize18px " >
                            <Thead >
                              <Tr>
                                <Th className="width150px  thtableImprimir  fontsize18px textaligmentcenter">Part Number:</Th>
                                <Th className="width300px thtableImprimir fontsize18px textaligmentcenter">Description:</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Revision:</Th>
                                <Th className="width200px thtableImprimir fontsize18px textaligmentcenter">Reference Annual Volume:</Th>
                                <Th className="thtableImprimir fontsize18px textaligmentcenter">Part area (SQF):</Th>

                              </Tr>
                            </Thead>
                            <Tbody>
                              <Tr>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.numerodeParte}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.descripcion}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.revision}</Td>
                                <Td className="fontsize18px textaligmentcenter" >{cotizacionImprimir.annualVolume}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.area}</Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <Table bordered className="margintop-10px mb-2  fontsize18px " >
                            <Thead >
                              <Tr>
                                <Th className="width150px thtableImprimir  fontsize18px textaligmentcenter">Packing type</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Packing Source</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Packing Instruction:</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Previous Process</Th>
                                {cotizacionImprimir.processEngineering !== 'Painting Tool' && (
                                  <Th className="width200px thtableImprimir fontsize18px textaligmentcenter">Zinc Plating Thickness (Microns)</Th>)}
                                {cotizacionImprimir.processEngineering !== 'Plating Tool' && (
                                  <Th className="thtableImprimir fontsize18px textaligmentcenter">Ecoat Thickness (Microns):</Th>)}

                              </Tr>
                            </Thead>
                            <Tbody>
                              <Tr>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.packigType}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.packingSource}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.packingINumber}</Td>
                                <Td className="fontsize18px textaligmentcenter" >{cotizacionImprimir.previousProcess ? cotizacionImprimir.previousProcess : "NA"}</Td>
                                {cotizacionImprimir.processEngineering !== 'Painting Tool' && (
                                  <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.zincPlating}</Td>)}
                                {cotizacionImprimir.processEngineering !== 'Plating Tool' && (
                                  <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.paintThickness}</Td>)}
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <Table bordered className="margintop-10px mb-2  fontsize18px " >
                            <Thead >
                              <Tr>
                                <Th className="width150px  thtableImprimir  fontsize18px textaligmentcenter">Physical sample received</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">PPAP Level Suggested</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Annual PPAP resumission</Th>
                                <Th className="width150px thtableImprimir fontsize18px textaligmentcenter">Annual spec resumission</Th>
                                <Th className="thtableImprimir fontsize18px textaligmentcenter">Customer specs provided</Th>

                              </Tr>
                            </Thead>
                            <Tbody>
                              <Tr>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.sampleReceived}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.PPAPLevel}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.aPPAPSubmission}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.aSpecRessumission}</Td>
                                <Td className="fontsize18px textaligmentcenter">{cotizacionImprimir.drawingSProvided}</Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <Table bordered className="margintop30px mb-2  fontsize18px " >
                            <Thead >
                              <Tr>
                                <Th className="  thtableImprimir  fontsize18px textaligmentcenter">Item#</Th>
                                <Th className=" thtableImprimir fontsize18px textaligmentcenter">Description:</Th>
                                <Th className=" thtableImprimir fontsize18px textaligmentcenter">Specific details (If any):</Th>
                                <Th className=" thtableImprimir fontsize18px textaligmentcenter">Price (U$D):</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {cotizacionImprimir.processEngineering === 'Both' && (
                                <>
                                  <Tr>
                                    <Td className="fontsize18px tbold textaligmentcenter">1.1</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">Ecoat</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">Ecoat per drawing spec.</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">${cotizacionImprimir.finalSalePrice}</Td>
                                  </Tr>
                                  <Tr>
                                    <Td className="fontsize18px tbold textaligmentcenter">1.2</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">Zinc Plating</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">Zinc Plating 0.0003", Clear Chromate</Td>
                                    <Td className="fontsize18px tbold textaligmentcenter">${cotizacionImprimir.finalPSalePrice}</Td>
                                  </Tr>
                                </>
                              )}
                              {cotizacionImprimir.processEngineering === 'Painting Tool' && (
                                <Tr>
                                  <Td className="fontsize18px tbold textaligmentcenter">1</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">Ecoat</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">Ecoat per drawing spec.</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">${cotizacionImprimir.finalSalePrice}</Td>
                                </Tr>
                              )}
                              {cotizacionImprimir.processEngineering === 'Plating Tool' && (
                                <Tr>
                                  <Td className="fontsize18px tbold textaligmentcenter">1</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">Zinc Plating</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">Zinc Plating 0.0003", Clear Chromate</Td>
                                  <Td className="fontsize18px tbold textaligmentcenter">${cotizacionImprimir.finalPSalePrice}</Td>
                                </Tr>
                              )}
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">2</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Transportation /Event</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Purchase Order Required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">$120.00</Td>
                              </Tr>
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">3</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Over Time hour/shift</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Purchase Order Required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">$850.00</Td>
                              </Tr>
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">4</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Non standard packaging/piece</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">No packing instruction provided. Cost of man hour if required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">$7.50</Td>
                              </Tr>
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">5</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Tooling</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Purchase Order Required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">$3200.00</Td>
                              </Tr>
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">6</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Inspection Device /Gauges</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Purchase Order Required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">TBD</Td>
                              </Tr>
                              <Tr>
                                <Td className="fontsize18px tbold textaligmentcenter">7</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">PPAP</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">Purchase Order Required</Td>
                                <Td className="fontsize18px tbold textaligmentcenter">$1500.00</Td>
                              </Tr>

                            </Tbody>
                          </Table>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop40px">
                          <p class=" tbold floatleft">Delivery terms: FOB our facility. Any shipment provided by CAS Global LLC and/or its subsidiaries will have the cost noted in this quote (if applicable).</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px floatleft">
                          <p class=" tbold textjustify">CAS Global LLC, Gladly presents you our quote for the painting services on the part number, under the annual volume, the details noted above and the specification noted on the drawing provided.</p>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12  floatleft">
                          <p class=" textjustify">Notes:</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-10px floatleft">
                          <p class=" textjustify">* Quote prepared by:</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-20px floatleft">
                          <p class=" textjustify"> * VAT taxes will be added to the price quoted if applicable.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-20px floatleft">
                          <p class=" textjustify"> * Payment should be received by wire transfer or check.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-20px floatleft">
                          <p class=" textjustify"> * Above quote is valid for 60 days.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-20px floatleft">
                          <p class=" textjustify">* Signature of this quotation implies agreement of the below listed Terms and Conditions.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-20px floatleft">
                          <p class=" textjustify"> * Terms and Conditions for ONE TIME CUSTOMERS may be substantially different than long term customers, to be determine by Sales.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12  floatleft">
                          <p class=" textjustify"> To accept this quotation, sign here:        X___________________________				and return to fax # above, or via email to Sales.		</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 floatleft">
                          <p class=" textjustify"> Please contact us for any question about this quote.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>APPLICABILITY: </strong>The Terms and Conditions outlined here, will govern the conditions for the Seller-Buyer relationship between Boon Tec International S de RL de CV (Seller) from CAS Global LLC's Group and the Customer (Buyer) while the business relationship remains active. The existing of a open Purchase Order and a shipping and collecting activities between Seller and Buyer assumes an active valid business relationship.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>PAINTING SERVICE APPROVAL: </strong>Customer agrees to provide Boon Tec International S de RL de CV, with a Purchase Order (PO) referred to the Quotation provided and a copy of a sub-maquila registration authorization previous to the first shipment of painted products (when applicable), where all costs related to the service shall be included, multiple PO's for the different quotation items may be provided. Customer agrees that commercial limitations or other restrictions, alterations, terms or conditions incorporated within the purchase order or financial authorization not explicitly cited within this contract are null and void and shall not be considered as part of this agreement. Any item or condition not included in the Quoted Price, such as tooling, quality gauges, packaging material, special packaging labor, transportation, masking, etc. shall be reviewed and agreed in written by both, Seller and Buyer and may result in a piece price or cost adjustment. Verbal agreements are not supported by Boon Tec International S de RL de CV.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-15px floatleft">
                          <p class="textjustify "> NOTE: Customer shall review the available paint capacity with Boon Tec International S de RL de CV's Sales Contact before issuing a Purchase Order.</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>PRODUCT LAUNCH AND READINESS: </strong>
                            Customer agrees to provide all the engineering information applicable to do the proper quoting, as a minimum the engineering drawing, paint specifications, annual/daily volumes and/or receiving/shipping standard pack. Also customer shall provide sample of parts for design, development and build of the necessary tooling. Boon Tec International S de RL de CV will take 28 calendar days after PO approval and receiving samples to do the first shipment of painted product assuming PPAP is approved. Rushing a project may require overtime approval at a rate mutually agreed by Seller and Buyer; a PO may be required for the implied costs.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>TERMS OF PAYMENT: </strong>
                            Customer agrees to pay Boon Tec International S de RL de CV for all services provided with approved credit NET 30 days upon receipt of invoice. Late payments are subject to a 2% late charge (24% annual) for each month that the full amount due or any portion thereof is unpaid. Customer agrees to pay Boon Tec International S de RL de CV. reasonable collection fees, attorney fees and any other expenses incurred for collection of any and all charges related to customer's account.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>MINIMUM WORK ORDER/VOLUME HANDLING: </strong>
                            When due to Customer planning a limited number of parts is released and required to be painted, the Minimum Work Order required for the paint process to be invoiced on any Part Number is 200.00 U$D. Volume increases in excess of 20% of the quoted daily amount for any part number, will be charged as overtime to the rate of 4,000.00 U$D/8 hours. Seller will advise in advance to obtain Buyer written approval and a Purchase Order shall be provided as authorization for a minimum of two hours during working week and a minimum of 8 hours during weekend. Daily volume received under 20% of the monthly average quoted will require price per piece adjustment unless something else agreed  in written between seller and buyer.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>LEAD TIME: </strong>
                            On any valid open PO, LEAD TIME for all parts received is max 72 hours after received in our dock. Lead time is valid under the assumption than the product is in good shape and free of any type of damage. The quoted price does not include inspection/sort, repack of product, rework, product assembly, special packaging, degreasing or corrosion removal; in the case the customer need these services they may be offered, quoted and invoiced separated under customer's written authorization.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>MATERIAL PROCESSABILITY: </strong>
                            All material received for painting at Boon Tec International S de RL de CV shall have water soluble rust inhibitor, otherwise the painting of the parts are not guaranteed and customer shall exempted Boon Tec International S de RL de CV of any financial responsibility on the resulting quality of the painted parts. Customer agrees to provide always stamped products using lubricants compatible with our cleaning,  pretreatment and paint process, in the understanding that failing to that will limit our ability to paint the parts. Harmonized Material Safety Data Sheets (MSDS) in Spanish for used stamping lubricants shall be provided before any sample run.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>TRANSPORTATION: </strong>
                            Customer is responsible for transportation from/and to Seller's facility of all materials for painting and painted. Receiving and shipping shall happen during normal business hours Monday thru Friday, as previously agreed with Boon Tec International S de RL de CV's contact person. We will not be responsible for any shortage due to labor trouble,  customer planning issues, material availability, damage to facilities, transportation arrangement or availability and/or any other cause out of our control. Urgencies on parts required by the customer shall be agreed in written with the customer contact person, and overtime charges may apply and a PO may be necessary.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>PROCESS CHANGES AT STAMPING: </strong>
                            Customer agrees that any change in the chemical substances used in the stamping process for current painting parts, is limited by the compatibility of all the components with the Boon Tec International S de RL de CV's paint process, thus the intended change shall have to be communicated in advance to Seller to evaluate the ability to paint the parts without affecting the expected quality. Also agrees that if a process change happens at the customer end without being evaluated and agreed by both Seller and Buyer,  and this change cause a major contamination to our paint process, requiring replacement and/or make up of all the solutions of the stages in our paint line; all the resulting damage, financial and environmental impact, residues disposition and cost to remake our paint solutions will be responsibility of the customer to the amount resulting of a damage assessment by an independent expert approved by Seller and Buyer for  impact analysis, that may increase customer's liability, as well as all resulting collection fees, attorney fees and any other expenses incurred for collection of any and all charges related to customer's account.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>PACKAGING: </strong>
                            Standard quoted packaging is bulk. The customer is responsible to provide all the packaging needed to assure the integrity of the product while transported and handled, along with the applicable packaging specifications; this includes but is not limited to returnable containers, cardboard boxes and partition, separators, plastic bags, pallets, and any item included in the packaging work instructions when applicable. Packaging specifications shall detail as a minimum the type of packaging, standard pack, arrangement, labeling requirements; any alternative packaging shall be agreed in written between Seller and Buyer. Packaging shall be free of any damage and/or contamination. Seller does not accept liability for packaging shortage, damages, handling issues or any incident caused by improper, contaminated, damaged or mishandled product beyond of our control.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>PRODUCT VALIDATION AND PPAP: </strong>
                            Boon Tec International S de RL de CV will monitor and validate the process stability in order to met the Engineering Drawing and Specifications.  A PPAP can be provided if required, which will include PSW, Process Flow Diagram, PFMEA, Control Plan, the results of thickness and paint inspection results. Performance test results required by an Accredited Test Laboratory will be included at customer's request and cost unless otherwise agreed between Seller and Buyer. Availability of the test results will be subject to the time and availability of the Accredited Quality Laboratories.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>LIMITATIONS OF WARRANTIES: </strong>
                            Boon Tec International S de RL de CV is neither a manufacturer nor a parts stamping company of the components, assemblies or materials to be painted or handled by Boon Tec International S de RL de CV, and makes no warranties either expressed or implied by the adherence to the provided Engineering Drawing and Specifications related to the painting services provided, that may and disclaims all warranties including but not limited to the warranty of merchantability and fitness for a particular purpose. Boon Tec International S de RL de CV, its agents, representatives and employees shall have no responsibility for direct, incidental, special or consequential damages arising from or in connection with the services provided or the use or failure of any parts or other materials. Customer specifically agrees not to make claim against, withhold, reduce or adjust payment or any portion thereof for services provided based on any outside contractual agreement or action that is not specifically cited as part of this contract, including but not limited to: third party charges, cost recoveries, travel, freight, equipment damage, equipment failure or financial hardship.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>DEFECTIVE PRODCT RESPONSIBILITY: </strong>
                            Customer agrees that E-Coat paint is not for appearance purposes, so Boon Tec International S de RL de CV will not be accountable for any cosmetic issue related to painted parts, unless agreed in written and the quality criteria be clearly agreed during launch process. Rack marks on painted parts are not considered a defect. Any defective painted part found at the customer side shall be previously communicated, reviewed and agreed with the Boon Tec International S de RL de CV's Quality Representative, who shall pre-approve any Return Material Authorization (RMA) in written when applicable. Any debit charge for defective product will have to be accepted  in advance by the Boon Tec International S de RL de CV Sales Representative, and solely for the paint service provided, administrative charges for complains issuing are not accepted unless revised and agreed between Seller and Buyer for specific cases. Under no circumstances Boon Tec International S de RL de CV will be responsible for paint issues caused by previous finish, damaged parts, bad stamping, malfunctioning parts or mishandling issues on any part painted or by any situation out of our control.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>SCRAP ALLOWANCE: </strong>
                            Boon Tec International S de RL de CV is committed to the maximum throughput from the painting process; however, customer agrees a shrinkage up to 2% in monthly basis but not more than 1% in a year period will be allowed for paint defects generated only and will keep Boon Tec International S de RL de CV, harmless of any debit related to that. THIS allowance is independent of any discrepancy that may occur between the amount of parts declared in the bill of lading/packing list or any document used to inform the amount of parts shipped from the customer and the real physical parts received. The Scrap allowance excludes any paint defect parts caused by problems related to stamper's responsibility such as grease, heat treat, excess of rust, silicon, adhesives, hydraulic oil and any other condition that may affect the paint process.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>NOTICE: </strong>
                            Any notice shall be given in writing and shall be delivered to the party at the address specified in this agreement, or such other address specified in writing.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>CHOICE OF LAW: </strong>
                            Any dispute pursuant to this agreement shall be decided in accordance with the laws of the State of Texas, and the customer agrees to be subject to the jurisdiction of the Court of Cameron County, Texas for USA based customers, regardless of the legal domicile of customer, place of business of the customer or the place  of transaction. Mexico based customers will be subject to the Tribunal Superior de Justicia del Estado de Tamaulipas.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>INSURANCE: </strong>
                            It shall be the sole responsibility of the customer to insure any parts or other materials that are in Boon Tec International S de RL de CV warehouse. The insurance shall cover liability for any loss, damage, injury or other casualty to property of the customer, and shall cover damage caused by fire, wind, storm, or other casualty to the full insurable replacement value of the property. Customer assumes the full risk of loss, and indemnifies and holds Boon Tec International S de RL de CV harmless for any loss.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>TERMINATION OF AGREEMENT AND SEVERABILITY: </strong>
                            Either Boon Tec International S de RL de CV or the customer may terminate this agreement at any time without cause after one year of painting services, provided that prior explicit written notice is given. If any portion of this agreement is held unenforceable, the remainder of the agreement remains in full force and effect. Tooling cost shall paid in full when customer terminates the paint services for a specific part number in less than 12 months from PO issuing, unless the program is exhausted on whose case, Seller should have been previously informed.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>ENTIRE AGREEMENT AND AMENDMENT: </strong>
                            This agreement contains the entire agreement between the parties with respect to the matters described herein  and is a complete and exclusive statement as to the terms thereof. This agreement may not be altered or modified except by an explicit writing signed by both parties.
                          </p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 ">
                          <p class=" floatleft textjustify "> <strong>ASSIGNMENT: </strong>
                            This agreement may be assigned by Boon Tec International S de RL de CV in whole or in part, and Boon Tec International S de RL de CV shall provide written notice of any such assignment.
                          </p>
                        </div>

                        <div class="footer">
                          {/* <p className="floatright margintop-16px mr-3">Doc ID: FOR-PR04</p> <br />
                                                    <p className="floatright margintop-16px mr-3">Revision:  2</p> <br />
                                                    <p className="floatright margintop-16px mr-3">Fecha:  20/Jul/2016</p>*/}
                        </div>
                      </div>
                    </div>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(planeaciones)}</div>*/}
                  </TabPane>
                </TabContent>
              </div>



            </Fragment>
          </div>
        </>
      )
      }
    </>
  )
};



export default Cotizacion
